/* eslint-disable no-unwrapped-jsx/no-unwrapped-jsx-text */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable quotes */
import React from 'react';
import { observer } from 'mobx-react';
import { Utils } from 'Utils/utils';
import { ReactComponent as PurchaseSuccess } from 'Assets/svg/new_icons/purchaseSuccess.svg';
import { advSearchState } from 'Stores/advSearch';
import { CommonPopupWithImageComponent } from 'Components/common/commonPopupWithImageComponent';
import userDetail from 'Stores/userDetail';
import '../../../styles/popup/_syncPurchaseExportMsg.scss';

const EmailMailToElement = ({ email }) => (
  <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
    {email}
  </a>
);

const FormatElementWithText = ({ number, text }) => (
  <b>
    {number} {text}
    <span>{number > 1 && 's'}</span>
  </b>
);

const DescriptionPurchase = props => {
  const {
    totalCount,
    totalPhoneCount,
    // newlyAddedCount,
    successCount,
    successPhoneCount,
    failedCount,
    isZbEnabled,
    isCreditLimitExhausted,
    contactIdsWithoutEmail = [],
  } = props;

  const contactsWithoutEmailAvl = contactIdsWithoutEmail.length > 0;

  return (
    <div className="purchase-info-wrapper">
      {isCreditLimitExhausted ? (
        <>
          You have requested for{' '}
          <FormatElementWithText number={totalCount} text="contact" />. We were
          able to provide you with{' '}
          <FormatElementWithText number={successCount} text="contact" />,
          because you have reached a maximum limit of credits allotted to you
          for the month. Please contact your administrator for more credits.
          <div className="summary-text">Please find the summary below:</div>
        </>
      ) : (
        <>
          We've successfully added{' '}
          {successCount > 1 || successPhoneCount > 1
            ? 'all the contacts'
            : 'a contact'}{' '}
          to your list. Please find the summary below:
        </>
      )}

      <div className="purchase-info-list">
        {/* <div className="purchase-info-item">
          <div className="label-section">Number of contacts requested</div>
          <div className="value-section">{Utils.numberFormat(totalCount)}</div>
        </div> */}
        {successCount > 0 && (
          <div className="purchase-info-item">
            <div className="label-section">Contacts added to List : </div>
            <div className="value-section">
              {Utils.numberFormat(successCount)}
            </div>
          </div>
        )}
        {totalPhoneCount > 0 && successPhoneCount > 0 && (
          <div className="purchase-info-item">
            <div className="label-section">Contacts with Mobile : </div>
            <div className="value-section">
              {Utils.numberFormat(successPhoneCount)}
            </div>
          </div>
        )}
        {/* {failedCount > 0 && (
          <div className="purchase-info-item">
            <div className="label-section">Contacts that were not added</div>
            <div className="value-section">
              {Utils.numberFormat(failedCount)}
            </div>
          </div>
        )}
        <div className="purchase-info-item">
          <div className="label-section">Credits used</div>
          <div className="value-section">
            {Utils.numberFormat(newlyAddedCount)}
          </div>
        </div> */}
      </div>
      {((failedCount > 0 && isZbEnabled) || contactsWithoutEmailAvl) && (
        <section className="note-wrapper">
          <div className="note-title">Note :</div>
          <ol
            className={
              failedCount > 0 && isZbEnabled && contactsWithoutEmailAvl
                ? ''
                : 'no-list-style'
            }
          >
            {isZbEnabled && failedCount > 0 && (
              <li>
                The contacts that failed the ZeroBounce real-time verification
                were not added to the list.
              </li>
            )}
            {contactsWithoutEmailAvl && (
              <li>Credits are not reduced for contacts without email</li>
            )}
          </ol>
        </section>
      )}
    </div>
  );
};

const DescriptionExport = props => {
  const {
    totalCount,
    newlyAddedCount,
    successCount,
    failedCount,
    isZbEnabled,
    isCRMExport,
    duplicateLeads,
    isCSVExport,
    isCreditLimitExhausted,
    contactIdsWithoutEmail = [],
  } = props;

  const showVerificationMessage = isZbEnabled && failedCount > 0;

  const isDuplicateMessage = isCRMExport && duplicateLeads > 0;

  const isContactWithoutEmail =
    (isCRMExport || isCSVExport) && contactIdsWithoutEmail.length > 0;

  const notShowList =
    !!showVerificationMessage +
      !!isDuplicateMessage +
      !!isContactWithoutEmail ===
    1;

  return (
    <div className="purchase-info-wrapper">
      {isCRMExport ? (
        <>
          {successCount === totalCount ? (
            <>
              We've successfully added{' '}
              {successCount > 1 ? 'all the contacts' : 'a contact'} to your CRM.
              Please find the summary below:
            </>
          ) : isCreditLimitExhausted &&
            !userDetail.userInfo.isEnterpriseAdmin ? (
            <>
              You have requested for{' '}
              <FormatElementWithText number={totalCount} text="contact" />. We
              were able to provide you with{' '}
              <FormatElementWithText number={successCount} text="contact" />,
              because you have reached a maximum limit of credits allotted to
              you for the month. Please contact your administrator for more
              credits.
              <div className="summary-text">Please find the summary below:</div>
            </>
          ) : (
            <>
              We've successfully added{' '}
              <FormatElementWithText number={successCount} text="contact" /> to
              your CRM out of the requested{' '}
              <FormatElementWithText number={totalCount} text="contact" />.
              Please find the summary below:
            </>
          )}
        </>
      ) : (
        <>
          {successCount === totalCount ? (
            <>
              We've successfully exported{' '}
              {successCount > 1 ? 'all the contacts' : 'a contact'}. Please find
              the summary below:
            </>
          ) : isCreditLimitExhausted ? (
            <>
              You have requested for{' '}
              <FormatElementWithText number={totalCount} text="contact" />. We
              were able to provide you with{' '}
              <FormatElementWithText number={successCount} text="contact" /> ,
              because you have reached a maximum limit of credits allotted to
              you for the month. Please contact your administrator for more
              credits.
              <div className="summary-text">Please find the summary below:</div>
            </>
          ) : (
            <>
              We've successfully exported{' '}
              <FormatElementWithText number={successCount} text="contact" /> out
              of the requested{' '}
              <FormatElementWithText number={totalCount} text="contact" />.
              Please find the summary below:
            </>
          )}
        </>
      )}

      <div className="purchase-info-list">
        <div className="purchase-info-item">
          <div className="label-section">Number of contacts requested</div>
          <div className="value-section">{Utils.numberFormat(totalCount)}</div>
        </div>
        <div className="purchase-info-item">
          <div className="label-section">Number of contacts exported</div>
          <div className="value-section">
            {Utils.numberFormat(successCount)}
          </div>
        </div>
        {failedCount > 0 && (
          <div className="purchase-info-item">
            <div className="label-section">Contacts not exported</div>
            <div className="value-section">
              {Utils.numberFormat(failedCount)}
            </div>
          </div>
        )}
        <div className="purchase-info-item">
          <div className="label-section">Credits used</div>
          <div className="value-section">
            {Utils.numberFormat(newlyAddedCount)}
          </div>
        </div>
      </div>
      {(showVerificationMessage ||
        isDuplicateMessage ||
        isContactWithoutEmail) && (
        <section className="note-wrapper">
          <div className="note-title">Note :</div>
          <ol className={notShowList ? 'no-list-style' : ''}>
            {showVerificationMessage && (
              <li>
                The actual count may vary post verification. Don&#39;t worry!
                Your credits will be deducted only for the verified contacts.
              </li>
            )}
            {isContactWithoutEmail && (
              <li>Contacts without email addresses were not exported.</li>
            )}
            {isDuplicateMessage && (
              <li>Contacts that were already in your CRM were not exported.</li>
            )}
          </ol>
        </section>
      )}
    </div>
  );
};

const SyncPurchaseInfoPopupWrapper = props => {
  const { syncPurchaseOrExportData } = props;

  const {
    type,
    totalCount = 0,
    newlyAddedCount,
    successCount,
    successPhoneCount,
    totalPhoneCount,
    isZbEnabled,
    duplicateLeads,
    isCreditLimitExhausted,
    contactIdsWithoutEmail,
  } = syncPurchaseOrExportData;

  const contactsWithoutEmailCount = contactIdsWithoutEmail.length;

  const handleHoldSuccessOkClick = () => {
    advSearchState.setSyncPurchaseOrExportData(null);
  };

  const isZBEnabled = Utils.isZeroBounceEnabled();

  const isPurchase = type === 'ADD_TO_LIST';
  const isCSVExport = type === 'CSV_EXPORT';
  const isCRMExport = type === 'CRM_EXPORT';
  const isError = type === 'UNKNOWN_ERROR';

  let titleText = isPurchase
    ? 'purchase '
    : isCSVExport || isCRMExport
    ? 'export '
    : '';

  const failedCount = totalCount - successCount;
  const failedPhoneCount = totalPhoneCount - successPhoneCount;

  let description = '';

  if (successCount > 0 || successPhoneCount > 0) {
    titleText += 'success';
    if (isPurchase)
      description = (
        <DescriptionPurchase
          totalCount={totalCount}
          totalPhoneCount={totalPhoneCount}
          newlyAddedCount={newlyAddedCount}
          successCount={successCount}
          successPhoneCount={successPhoneCount}
          failedCount={failedCount}
          isZbEnabled={isZbEnabled}
          isCreditLimitExhausted={isCreditLimitExhausted}
          contactIdsWithoutEmail={contactIdsWithoutEmail}
        />
      );
    else
      description = (
        <DescriptionExport
          totalCount={totalCount}
          duplicateLeads={duplicateLeads}
          newlyAddedCount={newlyAddedCount}
          successCount={successCount}
          failedCount={failedCount}
          isZbEnabled={isZbEnabled}
          isCSVExport={isCSVExport}
          isCRMExport={isCRMExport}
          isCreditLimitExhausted={isCreditLimitExhausted}
          contactIdsWithoutEmail={contactIdsWithoutEmail}
        />
      );
  } else {
    titleText += 'failed';
    let descriptionEmail = '';
    let descriptionPhone;
    if (failedCount > 0)
      if (isZBEnabled)
        if (isPurchase) {
          descriptionEmail =
            'Sorry, we could not validate the email id of the selected contacts through our ZeroBounce real-time verification. Therefore, we have not added them to the list.';
        } else if (
          isCRMExport &&
          duplicateLeads === totalCount &&
          duplicateLeads === 1
        ) {
          descriptionEmail =
            'Hey! Looks like you already have this contact in your CRM. To prevent duplication, we are not exporting it.';
        } else if (isCRMExport && duplicateLeads === totalCount) {
          descriptionEmail =
            'Hey! Looks like you already have all of these contacts in your CRM. To prevent duplication, we are not exporting them.';
        } else if (
          (isCRMExport || isCSVExport) &&
          contactsWithoutEmailCount === totalCount &&
          contactsWithoutEmailCount === 1
        ) {
          descriptionEmail =
            "Hey! It looks like this contact doesn't have an email address and hence we are not exporting this contact.";
        } else if (
          (isCRMExport || isCSVExport) &&
          contactsWithoutEmailCount === totalCount
        ) {
          descriptionEmail =
            "Hey! It looks like these contacts doesn't have email address and hence we are not exporting these contacts.";
        } else {
          descriptionEmail =
            'Sorry, we could not validate the email id of the selected contacts through our ZeroBounce real-time verification. Therefore, none of the contacts were exported.';
        }
      else if (duplicateLeads === totalCount && duplicateLeads === 1)
        descriptionEmail =
          'Hey! Looks like you already have this contact in your CRM. To prevent duplication, we are not exporting it.';
      else if (isCRMExport && duplicateLeads === totalCount)
        descriptionEmail =
          'Hey! Looks like you already have all of these contacts in your CRM. To prevent duplication, we are not exporting them.';
      else if (
        (isCRMExport || isCSVExport) &&
        contactsWithoutEmailCount === totalCount &&
        contactsWithoutEmailCount === 1
      )
        descriptionEmail =
          "Hey! It looks like this contact doesn't have an email address and hence we are not exporting this contact.";
      else if (
        (isCRMExport || isCSVExport) &&
        contactsWithoutEmailCount === totalCount
      )
        descriptionEmail =
          "Hey! It looks like these contacts doesn't have email address and hence we are not exporting these contacts.";
      else
        descriptionEmail = (
          <div>
            Sorry, we couldn't process your request. Please email us at{' '}
            <EmailMailToElement email="success@adapt.io" /> and we will help you
            resolve this issue.
          </div>
        );

    if (failedPhoneCount > 0)
      if (totalPhoneCount === 1)
        descriptionPhone =
          'Sorry, we could not find mobile number for the contact';
      else
        descriptionPhone =
          'Sorry, we could not find mobile number for these contacts.';

    description = (
      <ol
        className={
          !descriptionEmail || !descriptionPhone ? 'no-list-style' : ''
        }
      >
        {descriptionEmail && <li>{descriptionEmail}</li>}
        {descriptionPhone && <li>{descriptionPhone}</li>}
      </ol>
    );
  }

  return (
    <CommonPopupWithImageComponent
      svgImgComponent={<PurchaseSuccess />}
      customParentClass={`purchase-popup sync-purchase-export-msg-popup`}
      titleText={titleText}
      description={description}
      btnText="Ok"
      actionBtnCallback={handleHoldSuccessOkClick}
      clickOutsidePopupCallback={handleHoldSuccessOkClick}
      closeClickCallback={handleHoldSuccessOkClick}
      showCloseBtn
    />
  );
};

const SyncPurchaseInfoPopup = observer(props => {
  const { syncPurchaseOrExportData = null } = advSearchState;

  return syncPurchaseOrExportData !== null ? (
    <SyncPurchaseInfoPopupWrapper
      syncPurchaseOrExportData={syncPurchaseOrExportData}
    />
  ) : (
    ''
  );
});

export { SyncPurchaseInfoPopup };
export default SyncPurchaseInfoPopup;
